var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "absolute inset-0 bg-white z-10 flex flex-col" },
    [
      _c(
        "div",
        {
          staticClass: "h-20 border-b px-6 flex justify-between items-center",
          staticStyle: { "border-color": "#E6EBEF" },
        },
        [
          _c("div", { staticClass: "flex items-center" }, [
            _c(
              "button",
              {
                staticClass: "w-6 h-6",
                on: {
                  click: function ($event) {
                    return _vm.$emit("goBack")
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "pointer-events-none",
                  attrs: {
                    width: "24",
                    height: "24",
                    src: require("@/assets/images/meeting-note/arrow_left_gray.svg"),
                  },
                }),
              ]
            ),
            _c(
              "span",
              {
                staticClass: "ml-2 text-2xl font-bold",
                staticStyle: { color: "#2E3842" },
              },
              [_vm._v(_vm._s(_vm.meetingNote.title))]
            ),
          ]),
          _c("div", { staticClass: "flex items-center gap-x-2" }, [
            !_vm.isMeetingNoteCompleted
              ? _c("div", { staticClass: "flex items-center gap-x-2" }, [
                  _c("span", { staticClass: "text-red-400 leading-8" }, [
                    _vm._v(_vm._s(_vm.meetingNoteDurationForm)),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass:
                        "cursor-pointer rounded-full px-6 bg-red-50 px-4",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onClickMeetingNoteStop(_vm.meetingNote)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "text-red-500 font-bold leading-9" },
                        [
                          _vm._v(
                            _vm._s(
                              this.$t("extendMenu.meetingNote.summary.stop")
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "w-6 h-6",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/images/x_gray.svg") },
                }),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "h-16 flex",
          staticStyle: {
            "box-shadow": "0px 14px 28px -7px rgba(0, 0, 0, 0.04)",
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "flex-1 text-lg font-bold",
              class: { selected: _vm.selectedStt },
              on: { click: () => _vm.select("stt") },
            },
            [
              _vm._v(
                " " + _vm._s(this.$t("extendMenu.meetingNote.title")) + " "
              ),
            ]
          ),
          _vm.isSummaryCompleted
            ? _c(
                "button",
                {
                  staticClass: "flex-1 text-lg font-bold",
                  class: { selected: !_vm.selectedStt },
                  on: { click: () => _vm.select("aiSummary") },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(this.$t("extendMenu.meetingNote.summary.title")) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        { staticClass: "min-h-0 flex-1 p-6 flex flex-col gap-x-2" },
        [
          _c(
            "div",
            { staticClass: "flex justify-end gap-x-2" },
            [
              _vm.selectedStt
                ? _c(
                    "RoomMeetingNoteButton",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.onClickMeetingNoteDownload(_vm.meetingNote)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(this.$t("extendMenu.meetingNote.download.title"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.selectedStt && _vm.isMeetingNoteCompleted
                ? _c(
                    "RoomMeetingNoteButton",
                    {
                      class: {
                        "cursor-not-allowed":
                          _vm.isSummaryPending || _vm.isSummaryCompleted,
                      },
                      attrs: { color: "navy", download: false },
                      on: { click: _vm.onClickRequsetSummary },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          this.$t("extendMenu.meetingNote.ai.summary.request")
                        ) + " "
                      ),
                      _vm.isSummaryPending
                        ? _c(
                            "div",
                            { staticClass: "pl-2" },
                            [
                              true
                                ? _c("GrmLoadingCircle", {
                                    attrs: { size: "xs" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "relative" },
                [
                  _vm.selectedAiSummary && _vm.isSummaryCompleted
                    ? _c(
                        "RoomMeetingNoteButton",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onToggleIsOpenDownloadSummary(
                                _vm.meetingNote
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              this.$t(
                                "extendMenu.meetingNote.ai.summary.download.title"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "absolute z-50" },
                    [
                      _c("GrmMenu", {
                        attrs: {
                          list: _vm.summaryDownloadList,
                          open: _vm.isOpenDownloadList,
                        },
                        on: {
                          "update:open": function ($event) {
                            _vm.isOpenDownloadList = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "relative" },
                [
                  _vm.selectedAiSummary && _vm.isSummaryCompleted
                    ? _c(
                        "RoomMeetingNoteButton",
                        {
                          attrs: { color: "navy", download: false },
                          on: { click: _vm.onToggleIsOpenTranslationList },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              this.$t(
                                "extendMenu.meetingNote.ai.summary.translation"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "absolute z-50" },
                    [
                      _c("GrmMenu", {
                        attrs: {
                          list: _vm.translationLangList,
                          open: _vm.isOpenTranslationList,
                        },
                        on: {
                          "update:open": function ($event) {
                            _vm.isOpenTranslationList = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("perfect-scrollbar", { staticClass: "min-h-0 flex-1" }, [
            _vm.selectedStt
              ? _c(
                  "div",
                  { staticClass: "relative" },
                  _vm._l(_vm.meetingNote.stt, function (stt, i) {
                    return _c("div", { key: i, staticClass: "mt-6" }, [
                      _c("div", { staticClass: "space-x-1" }, [
                        _c(
                          "span",
                          {
                            staticClass: "font-bold",
                            style: {
                              color: _vm.isMe(stt.userId) ? "#015ECB" : "",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.getUsername(stt.userId)))]
                        ),
                        _c("time", [
                          _vm._v(
                            _vm._s(_vm.formattedDate(stt.date || stt.regDate))
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "mt-2",
                          class: { "font-bold": _vm.isMe(stt.userId) },
                        },
                        [_vm._v(" " + _vm._s(stt.text) + " ")]
                      ),
                    ])
                  }),
                  0
                )
              : _vm.isSummaryCompleted
              ? _c("div", { ref: "summaryRef", staticClass: "mt-10" }, [
                  _vm.translationCompleted
                    ? _c("div", [
                        _c("p", { staticClass: "font-bold mb-3" }, [
                          _vm._v("Translation Content"),
                        ]),
                        _c(
                          "pre",
                          {
                            staticClass: "whitespace-pre-wrap",
                            staticStyle: { "word-break": "keep-all" },
                          },
                          [_vm._v(_vm._s(_vm.translatedSummary))]
                        ),
                      ])
                    : _c("div", [
                        _c("p", { staticClass: "font-bold mb-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "extendMenu.meetingNote.translationContent"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "pre",
                          {
                            staticClass: "whitespace-pre-wrap",
                            staticStyle: { "word-break": "keep-all" },
                          },
                          [_vm._v(_vm._s(_vm.meetingNote.summary))]
                        ),
                      ]),
                ])
              : _vm._e(),
            _c(
              "div",
              [
                _c("vue-html2pdf", {
                  ref: "html2Pdf",
                  attrs: {
                    "show-layout": false,
                    "enable-download": true,
                    "preview-modal": false,
                    "manual-pagination": false,
                    "paginate-elements-by-height": 3000,
                    "pdf-format": "b4",
                    filename: "ai_summary",
                  },
                  on: { hasDownloaded: _vm.onDownloadPdf },
                  scopedSlots: _vm._u([
                    {
                      key: "pdf-content",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "pdf-download-wrapper" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  `${_vm.$t(
                                    "extendMenu.meetingNote.meetingDate"
                                  )}: ${_vm.getFormedDate(
                                    _vm.meetingNote.startDate
                                  )} ~ ${_vm.getFormedTime(
                                    _vm.meetingNote.endDate
                                  )}`
                                )
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  `${_vm.$t(
                                    "extendMenu.meetingNote.writer"
                                  )}: ${
                                    _vm.getUsername(_vm.meetingNote.userId) ||
                                    _vm.$t("extendMenu.meetingNote.leavedUser")
                                  }`
                                ) + " "
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  `${_vm.$t(
                                    "extendMenu.meetingNote.summary.content"
                                  )}`
                                )
                              ),
                            ]),
                            _vm.translationCompleted
                              ? _c("div", [
                                  _c(
                                    "pre",
                                    {
                                      staticClass: "whitespace-pre-wrap",
                                      staticStyle: { "word-break": "keep-all" },
                                    },
                                    [_vm._v(_vm._s(_vm.translatedSummary))]
                                  ),
                                ])
                              : _c("div", [
                                  _c(
                                    "pre",
                                    {
                                      staticClass: "whitespace-pre-wrap",
                                      staticStyle: { "word-break": "keep-all" },
                                    },
                                    [_vm._v(_vm._s(_vm.meetingNote.summary))]
                                  ),
                                ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm.isTranslating
              ? _c(
                  "div",
                  {
                    ref: "translatingLoadingRef",
                    staticClass: "opacity-80 absolute left-0 is-translating",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        `${this.$t(
                          "extendMenu.meetingNote.summary.translation.progress"
                        )}`
                      )
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }